import React, { useState } from 'react';
import { IconArrowLeft, IconEye, IconEyeOff, IconCheck, IconLock, IconShieldCheck } from '@tabler/icons-react';
interface PasswordPageProps {
  onBack: () => void;
}
export function PasswordPage({
  onBack
}: PasswordPageProps) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [twoFactorEnabled, setTwoFactorEnabled] = useState(false);
  const passwordStrength = (password: string) => {
    if (password.length === 0) return {
      strength: 0,
      label: '',
      color: ''
    };
    if (password.length < 6) return {
      strength: 1,
      label: 'Debole',
      color: '#FAD88A'
    };
    if (password.length < 10) return {
      strength: 2,
      label: 'Media',
      color: '#AEDAFF'
    };
    return {
      strength: 3,
      label: 'Forte',
      color: '#B0EC9C'
    };
  };
  const strength = passwordStrength(newPassword);
  const canSave = currentPassword && newPassword && newPassword === confirmPassword && newPassword.length >= 8;
  const handleSave = () => {
    if (canSave) {
      console.log('Change password');
      // TODO: Save to backend
      setCurrentPassword('');
      setNewPassword('');
      setConfirmPassword('');
    }
  };
  return <div className="flex flex-col h-full" data-id="element-1021">
      {/* Header */}
      <div className="px-4 pt-4 pb-3 border-b border-yeppy-text border-opacity-10" data-id="element-1022">
        <div className="flex items-center gap-3 mb-3" data-id="element-1023">
          <button onClick={onBack} className="flex items-center gap-1 py-2 pr-2 transition-opacity hover:opacity-70" aria-label="Torna a Impostazioni" data-id="element-1024">
            <IconArrowLeft className="w-5 h-5 text-yeppy-text" stroke={2} data-id="element-1025" />
            <span className="font-poppins text-base text-yeppy-text font-medium" data-id="element-1026">
              Impostazioni
            </span>
          </button>
          <div className="flex-1 flex justify-end" data-id="element-1027">
            <h1 className="font-rubik font-bold text-lg text-yeppy-text" data-id="element-1028">
              Password
            </h1>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto px-4 py-6" data-id="element-1029">
        <div className="max-w-md mx-auto space-y-6" data-id="element-1030">
          {/* Change Password Section */}
          <div className="bg-white border border-yeppy-text border-opacity-10 rounded-2xl p-5" data-id="element-1031">
            <div className="flex items-center gap-3 mb-4" data-id="element-1032">
              <div className="w-10 h-10 rounded-xl bg-yeppy-bg flex items-center justify-center" data-id="element-1033">
                <IconLock className="w-5 h-5 text-yeppy-text" stroke={1.5} data-id="element-1034" />
              </div>
              <h2 className="font-rubik font-semibold text-base text-yeppy-text" data-id="element-1035">
                Cambia password
              </h2>
            </div>

            <div className="space-y-4" data-id="element-1036">
              {/* Current Password */}
              <div data-id="element-1037">
                <label htmlFor="current-password" className="block font-poppins text-sm font-medium text-yeppy-text mb-2" data-id="element-1038">
                  Password attuale
                </label>
                <div className="relative" data-id="element-1039">
                  <IconLock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-1040" />
                  <input id="current-password" type={showCurrentPassword ? 'text' : 'password'} value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} className="w-full px-4 py-3 pr-12 rounded-xl font-poppins text-sm text-yeppy-text bg-white border border-yeppy-text border-opacity-15 focus:outline-none focus:border-yeppy-blue focus:border-opacity-50 transition-colors" data-id="element-1041" />
                  <button type="button" onClick={() => setShowCurrentPassword(!showCurrentPassword)} className="absolute right-4 top-1/2 -translate-y-1/2" data-id="element-1042">
                    {showCurrentPassword ? <IconEyeOff className="w-5 h-5 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-1043" /> : <IconEye className="w-5 h-5 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-1044" />}
                  </button>
                </div>
              </div>

              {/* New Password */}
              <div data-id="element-1045">
                <label htmlFor="new-password" className="block font-poppins text-sm font-medium text-yeppy-text mb-2" data-id="element-1046">
                  Nuova password
                </label>
                <div className="relative" data-id="element-1047">
                  <IconLock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-1048" />
                  <input id="new-password" type={showNewPassword ? 'text' : 'password'} value={newPassword} onChange={e => setNewPassword(e.target.value)} className="w-full px-4 py-3 pr-12 rounded-xl font-poppins text-sm text-yeppy-text bg-white border border-yeppy-text border-opacity-15 focus:outline-none focus:border-yeppy-blue focus:border-opacity-50 transition-colors" data-id="element-1049" />
                  <button type="button" onClick={() => setShowNewPassword(!showNewPassword)} className="absolute right-4 top-1/2 -translate-y-1/2" data-id="element-1050">
                    {showNewPassword ? <IconEyeOff className="w-5 h-5 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-1051" /> : <IconEye className="w-5 h-5 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-1052" />}
                  </button>
                </div>
                {newPassword && <div className="mt-2" data-id="element-1053">
                    <div className="flex items-center gap-2 mb-1" data-id="element-1054">
                      <div className="flex-1 h-1.5 bg-yeppy-bg rounded-full overflow-hidden" data-id="element-1055">
                        <div className="h-full rounded-full transition-all duration-300" style={{
                      width: `${strength.strength / 3 * 100}%`,
                      backgroundColor: strength.color
                    }} data-id="element-1056" />
                      </div>
                      <span className="font-poppins text-xs font-medium" style={{
                    color: strength.color
                  }} data-id="element-1057">
                        {strength.label}
                      </span>
                    </div>
                    <p className="font-poppins text-xs text-yeppy-text text-opacity-60" data-id="element-1058">
                      Minimo 8 caratteri
                    </p>
                  </div>}
              </div>

              {/* Confirm Password */}
              <div data-id="element-1059">
                <label htmlFor="confirm-password" className="block font-poppins text-sm font-medium text-yeppy-text mb-2" data-id="element-1060">
                  Conferma password
                </label>
                <div className="relative" data-id="element-1061">
                  <IconLock className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-1062" />
                  <input id="confirm-password" type={showConfirmPassword ? 'text' : 'password'} value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} className="w-full px-4 py-3 pr-12 rounded-xl font-poppins text-sm text-yeppy-text bg-white border border-yeppy-text border-opacity-15 focus:outline-none focus:border-yeppy-blue focus:border-opacity-50 transition-colors" data-id="element-1063" />
                  <button type="button" onClick={() => setShowConfirmPassword(!showConfirmPassword)} className="absolute right-4 top-1/2 -translate-y-1/2" data-id="element-1064">
                    {showConfirmPassword ? <IconEyeOff className="w-5 h-5 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-1065" /> : <IconEye className="w-5 h-5 text-yeppy-text text-opacity-40" stroke={1.5} data-id="element-1066" />}
                  </button>
                </div>
                {confirmPassword && newPassword !== confirmPassword && <p className="mt-2 font-poppins text-xs text-yeppy-text text-opacity-60" data-id="element-1067">
                    Le password non coincidono
                  </p>}
              </div>

              {/* Save Button */}
              <button onClick={handleSave} disabled={!canSave} className="w-full flex items-center justify-center gap-2 px-4 py-3 rounded-xl font-poppins text-sm font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed" style={{
              backgroundColor: '#1D2A36',
              color: '#FFFFFB'
            }} data-id="element-1068">
                <IconCheck className="w-5 h-5" stroke={1.5} data-id="element-1069" />
                Cambia password
              </button>
            </div>
          </div>

          {/* Two-Factor Authentication */}
          <div className="bg-white border border-yeppy-text border-opacity-10 rounded-2xl p-5" data-id="element-1070">
            <div className="flex items-start gap-3" data-id="element-1071">
              <div className="w-10 h-10 rounded-xl bg-yeppy-bg flex items-center justify-center flex-shrink-0" data-id="element-1072">
                <IconShieldCheck className="w-5 h-5 text-yeppy-text" stroke={1.5} data-id="element-1073" />
              </div>
              <div className="flex-1 min-w-0" data-id="element-1074">
                <h2 className="font-rubik font-semibold text-base text-yeppy-text mb-1" data-id="element-1075">
                  Autenticazione a due fattori
                </h2>
                <p className="font-poppins text-sm text-yeppy-text text-opacity-60 mb-3" data-id="element-1076">
                  Aggiungi un ulteriore livello di sicurezza al tuo account
                </p>
                <label className="flex items-center gap-3 cursor-pointer" data-id="element-1077">
                  <div className="relative" data-id="element-1078">
                    <input type="checkbox" checked={twoFactorEnabled} onChange={e => setTwoFactorEnabled(e.target.checked)} className="sr-only peer" data-id="element-1079" />
                    <div className="w-11 h-6 bg-yeppy-bg rounded-full peer-checked:bg-yeppy-blue transition-colors" data-id="element-1080"></div>
                    <div className="absolute left-1 top-1 w-4 h-4 bg-white rounded-full transition-transform peer-checked:translate-x-5" data-id="element-1081"></div>
                  </div>
                  <span className="font-poppins text-sm text-yeppy-text" data-id="element-1082">
                    {twoFactorEnabled ? 'Attiva' : 'Disattiva'}
                  </span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}